import { render, staticRenderFns } from "./Yhgl.vue?vue&type=template&id=8e06ccee"
import script from "./Yhgl.vue?vue&type=script&lang=js"
export * from "./Yhgl.vue?vue&type=script&lang=js"
import style0 from "./Yhgl.vue?vue&type=style&index=0&id=8e06ccee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports